import { render, staticRenderFns } from "./ViewPdf.vue?vue&type=template&id=5d47850f&scoped=true"
import script from "./ViewPdf.vue?vue&type=script&lang=js"
export * from "./ViewPdf.vue?vue&type=script&lang=js"
import style0 from "./ViewPdf.vue?vue&type=style&index=0&id=5d47850f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d47850f",
  null
  
)

export default component.exports